import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Grid } from 'react-flexbox-grid';

import NotificationsSystem from 'reapop';

import { fetchWebValues } from 'actions/WebValues';
import { requestLanguage } from 'actions/language';

import en from 'react-intl/locale-data/en';
import is from 'react-intl/locale-data/is';

import { IntlProvider, addLocaleData } from 'react-intl';

import { get } from 'lodash';

import Loading from 'components/Loading';
import Toolbar from '../components/Toolbar';
// import Footer from '../components/Footer';

import { version } from '../../package.json';

import theme from '../themes/notifications';

const styles = {
  grid: {
    width: '100%',
    padding: 0,
    marginBottom: 0,
    paddingTop: 64,
  },
};

addLocaleData([...en, ...is]);

class App extends React.Component {
  componentDidMount() {
    const { isAuthenticated, fetchValues } = this.props;
    isAuthenticated && fetchValues();
  }
  // Logic to check if the route being entered is suposed to be hidden from view.
  componentWillReceiveProps({
    isAuthenticated, routes, router, fetchingValues, valuesLoaded, valuesByKey,
  }) {
    if (!valuesLoaded && !fetchingValues && isAuthenticated) {
      this.props.fetchValues();
    } else {
      const { ID, autoHide } = routes[routes.length - 1];
      if (valuesLoaded && valuesByKey
        && (
          (!autoHide && valuesByKey[`Hide.${ID}`] && valuesByKey[`Hide.${ID}`].Value === 'true')
          || (autoHide && get(valuesByKey, [`Show.${ID}`, 'Value']) !== 'true')
        )) {
        router.replace('/404');
      }
    }
  }

  render() {
    const {
      routes, valuesLoaded, isAuthenticated, messages, language,
    } = this.props;
    const title = routes.slice(-1)[0].name;
    return (
      <IntlProvider
        locale={language}
        messages={messages}
      >
        <div>
          <NotificationsSystem theme={theme} />
          <Helmet>
            <title>{title || 'Starfsmannavefur'}</title>
            <meta name="kjarni-version" content={version} />
          </Helmet>
          <Toolbar {...this.props} />
          <Grid fluid style={styles.grid}>
            {(valuesLoaded || !isAuthenticated) ?
            this.props.children :
            <Loading />}
          </Grid>
        </div>
      </IntlProvider>
    );
  }
}

function mapStateToProps({ loginReducer, WebValuesReducer, languageReducer }) {
  return {
    isAuthenticated: loginReducer.isAuthenticated,
    valuesByKey: WebValuesReducer.valuesByKey,
    valuesLoaded: WebValuesReducer.loaded,
    fetchingValues: WebValuesReducer.isFetching,
    ...languageReducer,
  };
}

App.propTypes = {
  children: PropTypes.object,
  valuesByKey: PropTypes.object,
  router: PropTypes.object,
  messages: PropTypes.object,
  language: PropTypes.string,
  valuesLoaded: PropTypes.bool,
  fetchingValues: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  fetchValues: PropTypes.func.isRequired,
  routes: PropTypes.array,
};

export default connect(
  mapStateToProps,
  dispatch => ({
    fetchValues: () => dispatch(fetchWebValues()),
    requestLanguage: language => dispatch(requestLanguage(language)),
  }),
)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js